import Box from "@mui/material/Box";
import SvgIcon from "@mui/material/SvgIcon";
import { alpha } from "@mui/material/styles";

const LIGHTNING_PATH =
  "M30.8377 10.2861H16.7529C16.3371 10.2861 16 10.6232 16 11.0391V26.6414C16 27.0573 16.3371 27.3944 16.7529 27.3944H20.8941C21.31 27.3944 21.6471 27.7315 21.6471 28.1473V37.3019C21.6471 38.064 22.6496 38.3437 23.0442 37.6917L31.3085 24.035C31.6121 23.5332 31.2508 22.8922 30.6643 22.8922H27.5153C26.9694 22.8922 26.605 22.3296 26.8281 21.8314L31.5248 11.3469C31.748 10.8488 31.3835 10.2861 30.8377 10.2861Z";

/** Plan dialog header icon: lightning in primary color on 8% primary background. */
export function SelectPlanDialogIcon() {
  return (
    <Box
      aria-hidden
      sx={{
        width: 48,
        height: 48,
        borderRadius: "8px",
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <SvgIcon
        viewBox="0 0 48 48"
        sx={{ width: 48, height: 48, color: "primary.main" }}
      >
        <path d={LIGHTNING_PATH} fill="currentColor" />
      </SvgIcon>
    </Box>
  );
}
